export function ParentsNote() {
  return (
    <section className="py-24 bg-block-pink">
      <div className="max-w-3xl mx-auto px-4 sm:px-8 text-center">
        <p className="text-caption text-primary mb-3">家长视图 · 学习周报</p>
        <h2 className="text-heading text-ink mb-4">给家长的一句话</h2>
        <p className="text-body text-ink-soft">
          周报会告诉你孩子这周学了多久、练得怎么样——不看具体题目。
          学习是孩子自己的事，了解进度是家长的事。
        </p>
      </div>
    </section>
  )
}
